import React from "react";

const Stack = () => {
  return (
    <React.Fragment>
      <h3 className="title-font white-text ">
        Here are a few tools & technologies I’ve been working with:
      </h3>
      <ol className="stack-section ">
        <li>C/C++, Python, Java, JavaScript</li>
        <li>CAN, SPI, UART, I2C</li>
        <li>AUTOSAR</li>
        <li>Github</li>
        <li>Git</li>
        <li>Figma</li>
      </ol>
    </React.Fragment>
  );
};
export default Stack;
